import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

export const useGoCardlessIntegration = () => {
  const goCardlessIntegration = useQuery(
    dashboard20240730Client.getIntegration,
    'GoCardless'
  )

  return {
    enabled: goCardlessIntegration.data?.state === 'CONNECTED',
    isLoading: goCardlessIntegration.isLoading
  }
}
